<template>
  <div>
     <Menu></Menu>
   
     <Cupom ref="Cupom" />
    
     <div class="grid-responsive">
       <br>
          <h1 class="title">Relatório</h1>
          <br />      <br />          
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Criação</th>
                  <th>Cod. Promoção</th>
                  <th>Cod. Cupom</th>
                  <th>Serviço</th>                    
                  <th>Valor do Serviço</th>
                  <th>Valor à repassar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{item.timezoneMotorista}}</td>   
                  <td>{{item.idPromocao}}</td>
                  <td>{{item.idCupom}}</td>
                  <td>{{item.nomeServico}}</td>                                      
                  <td>{{item.valorServico}}</td>   
                  <td>{{item.taxa}}</td>   
                </tr>
                <tr>
                  <td colspan="5"></td>
                  <td>
                    <strong>R$ {{this.taxa}}</strong>
                  </td>
                   
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
   
</template>

<style scoped>
tfoot {
  background-color: #fff;
}
#buttonActions {
  margin-top: 30px;
}
</style>

<script>

import Menu from "@/components/MenuParceiro.vue";


import {ParceiroService} from "@/http"

import moment from 'moment'

import {formatPrice} from "@/utils"
 
export default {
  name: "companyCampaign",
  components: {
    Menu,     
  },
  data: () => {
    return {
      items:[],
      taxa: 0, 
     };
  },
  methods: {
     visualizarCupom(cupom){
       this.$refs["Cupom"].visualizarCupom(cupom)
     }, 
      
     cupons(){
        ParceiroService.Relatorio().then(response=>{ 
            
              this.items = response.data.map(item=>{

                  item.timezoneMotorista = moment(item.timezoneMotorista).utc().locale("pt-br").format("LLL")

                  if(item.KIT){
                    item.valorServico = item.valorComDesconto
                  }

                  const preco = item.valorServico / 100
                  const taxa = (0.1 * preco)

                  this.taxa += taxa 
                  
                  item.valorServico = formatPrice(preco)
                  item.taxa         = formatPrice(taxa)
                   
                  return item
              })
            this.taxa = formatPrice(this.taxa)

        }).catch(err =>{
            window.console.log(err.response)
        })
     }
     
  },
  created() {
     this.cupons()   
  }, 
   
};
</script>
 
